"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackContainer = void 0;
var React = require("react");
var constants_1 = require("./constants");
var styles_1 = require("./styles");
exports.SnackContainer = function () {
    return (React.createElement(styles_1.StyledSnackContainer, { id: "" + constants_1.CONTAINER_CLASS_NAME, className: "" + constants_1.CONTAINER_CLASS_NAME },
        React.createElement(styles_1.StyledSnackRow, null,
            React.createElement(styles_1.StyledSnackTop, { id: "" + constants_1.TOP_LEFT }),
            React.createElement(styles_1.StyledSnackTop, { id: "" + constants_1.TOP_CENTER }),
            React.createElement(styles_1.StyledSnackTop, { id: "" + constants_1.TOP_RIGHT })),
        React.createElement(styles_1.StyledSnackRow, null,
            React.createElement(styles_1.StyledSnackBottom, { id: "" + constants_1.BOTTOM_LEFT }),
            React.createElement(styles_1.StyledSnackBottom, { id: "" + constants_1.BOTTOM_CENTER }),
            React.createElement(styles_1.StyledSnackBottom, { id: "" + constants_1.BOTTOM_RIGHT }))));
};
//# sourceMappingURL=ApSnackContainer.js.map